import { notificationApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';
import { TanstackTableSearchParamsAdapter } from '@itm/shared-frontend/lib/utils';

import {
  CompanyTemplateModuleDto,
  TemplateContentWriteRequest,
  TemplateDetailsDto,
  TemplateListResponseDto,
  TemplateRecipientsWriteRequest,
  TemplateTestEmailRequest,
  TemplateWriteRequest,
  TenantTemplateModuleDto,
} from 'src/types';

export type TemplateListSearchParams = {
  moduleId?: string;
} & TanstackTableSearchParamsAdapter;

export const getTemplateSummaryByTenant = (tenantId: string, config: AxiosRequestConfig = {}) =>
  notificationApi.get<TenantTemplateModuleDto[]>(`/api/v1/templates/tenants/${tenantId}/summary`, config);

export const getTemplateSummaryByCompany = (companyId: string, config: AxiosRequestConfig = {}) =>
  notificationApi.get<CompanyTemplateModuleDto[]>(`/api/v1/templates/companies/${companyId}/summary`, config);

export const getTemplateListByTenant = (
  tenantId: string,
  params: TemplateListSearchParams,
  config: AxiosRequestConfig = {},
) => notificationApi.get<TemplateListResponseDto>(`/api/v1/templates/tenants/${tenantId}`, { ...config, params });

export const getTemplateListByCompany = (
  companyId: string,
  params: TemplateListSearchParams,
  config: AxiosRequestConfig = {},
) => notificationApi.get<TemplateListResponseDto>(`/api/v1/templates/companies/${companyId}`, { ...config, params });

export const getTemplateById = (templateId: string, companyId?: string, config: AxiosRequestConfig = {}) =>
  notificationApi.get<TemplateDetailsDto>(`/api/v1/templates/${templateId}`, {
    ...config,
    params: { companyId },
  });

export const enableTemplate = (data: TemplateWriteRequest) =>
  notificationApi.patch<string>('/api/v1/templates/enable', data);

export const disableTemplate = (data: TemplateWriteRequest) =>
  notificationApi.patch<string>('/api/v1/templates/disable', data);

export const updateTemplateRecipients = (data: TemplateRecipientsWriteRequest) =>
  notificationApi.patch<string>('/api/v1/templates/recipients', data);

export const updateTemplateContent = (data: TemplateContentWriteRequest, config: AxiosRequestConfig = {}) =>
  notificationApi.patch<string>('/api/v1/templates/content', data, config);

export const resetTemplateContent = (templateId: string) =>
  notificationApi.post<string>(`/api/v1/templates/${templateId}/reset-content`);

export const sendTemplateTestEmail = (data: TemplateTestEmailRequest, config: AxiosRequestConfig = {}) =>
  notificationApi.post<void>('/api/v1/templates/send-test-email', data, config);

export const uploadTemplateImage = (data: FormData, config: AxiosRequestConfig = {}) =>
  notificationApi.post<string>('/api/v1/templates/images', data, config);
